import { render, staticRenderFns } from "./StrategiesEditor.vue?vue&type=template&id=7a70f619&scoped=true&"
import script from "./StrategiesEditor.vue?vue&type=script&lang=js&"
export * from "./StrategiesEditor.vue?vue&type=script&lang=js&"
import style0 from "./StrategiesEditor.vue?vue&type=style&index=0&id=7a70f619&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70f619",
  null
  
)

export default component.exports